// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__72ihQ","label":"Radio_label__3DKKJ","checkMark":"Radio_checkMark__3ONRo","disabled":"Radio_disabled__s_1e5"};